<template>
  <Membresias />
</template>

<script>
import Membresias from '@/components/Membresias/Membresias.vue'
export default {
  name: 'MembresiasView',
  components: { Membresias }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/MembresiasView.vue